import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { fetchDocumentStatusByProject } from '../../../services/document';
import * as actions from '../documentActions';

export default function* fetchDocStatusByProjectWatcher() {
  yield takeLatest(actions.FETCH_DOC_STATUS_BY_PROJ, fetchDocStatusByProjectWorker);
}

export function* fetchDocStatusByProjectWorker(action) {
  try {
    if (!action?.closing_id) {
      throw new Error("Missing required parameter: closing_id");
    }

    const response = yield call(fetchDocumentStatusByProject, action.closing_id);

    if (!response || typeof response !== "object") {
      yield call(success, {
        data: [],
        message: "No data returned from server",
        degraded: true,
      });
      return;
    }

    yield call(success, response);

  } catch (error) {
    const normalizedError = {
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Unexpected error occurred while fetching document status.",
      status: error?.response?.status || null,
      raw: error,
    };

    yield call(failure, normalizedError.message);
  }
}

export function* success(response) {
  yield put(actions.loadingDocStatusByProj(false));

  const errors = _.get(response, 'errors', []);
  if (errors.length > 0) {
    yield call(failure, new Error('Failed to retrieve document status'));
    return;
  }

  const data = _.get(response, 'data.documentStatusByProject') || {};

  yield put(actions.setDocStatusByProj(data));
}

export function* failure(errorMessage) {
  yield put(actions.loadingDocStatusByProj(false));
  yield put(actions.errorDocStatusByProj(errorMessage || 'An unexpected error occurred while fetching document status'));
}
